module.exports = __webpack_public_path__ + "static/media/firework_3.b6a95608.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/static/audio/firework_3.mp3
// module id = 654
// module chunks = 0